<template>
  <div ref="container">
    <div class="wrapper" ref="arrow" :style="transformStyle">
      <div class="arrow">
        <div class="fill"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      transform: {
        type: Number,
        default: 0,
        validator: value => {
          return value >= 0 && value % 1 === 0;
        }
      },
      count: {
        type: Number,
        default: 1,
        required: false,
        validator: value => {
          return value > 0 && value % 1 === 0;
        }
      }
    },
    computed: {
      transformStyle() {
        const a = this.transform;

        if (!this.$refs || !this.$refs.container || !this.$refs.arrow) {
          return {};
        }

        const outer = this.$refs.arrow.offsetHeight;

        if (window && window.document.body.offsetWidth <= 990) {
          const width = this.$refs.container.offsetWidth;
          const p = Math.floor(
            ((width - outer) * this.transform) / (this.count - 1),
            2
          );
          return {
            transform: `translateX(${p}px)`
          };
        }

        const height = this.$refs.container.offsetHeight;
        const p = Math.floor(
          ((height - outer) * this.transform) / (this.count - 1),
          2
        );
        return {
          transform: `translateY(${p}px)`
        };
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  $parent-mark: 16px;
  $size: 14px;
  $arr-size: 9.99px;
  .wrapper {
    width: $parent-mark;
    height: $parent-mark;
    transition: all 1s;

    .arrow {
      width: $size;
      height: $size;
      margin-top: ($parent-mark - $size) / 2;
      margin-right: ($parent-mark - $size) / 2;
      overflow: hidden;
      position: relative;
      @include respond-to(tabletRotate) {
        margin-right: 0;
        margin-left: ($parent-mark - $size) / 2;
      }
    }
    .fill {
      background: #feea01;
      width: $arr-size;
      height: $arr-size;
      position: absolute;

      transform: rotate(45deg);
      right: -2px;
      transform-origin: 50% 100%;
      @include respond-to(tabletRotate) {
        transform: rotate(45deg);
        top: -2px;
        right: auto;
        transform-origin: 100% 50%;
      }
    }
    @include respond-to(tablet) {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CounterMarks/components/DynamicArrow.vue